import { gunzip, gzip, strFromU8, strToU8 } from 'fflate';

type BinaryPayload = ArrayBuffer | ArrayBufferView;

const textEncoder = new TextEncoder();

const CompressionHelpers = {
    calculateStringSize: (string: string) => {
        return textEncoder.encode(string).length;
    },

    isBinary: (data: unknown): data is BinaryPayload => {
        return data instanceof ArrayBuffer || ArrayBuffer.isView(data);
    },

    compress: async (string: string) => {
        return new Promise<Uint8Array>((resolve, reject) => {
            const u8 = strToU8(string);

            gzip(u8, (err, compressed) => {
                if (err) {
                    reject(err);
                    return;
                }
                resolve(compressed);
            });
        });
    },

    decompress: (payload: BinaryPayload) => {
        return new Promise<string>((resolve, reject) => {
            gunzip(toBytes(payload), (err, decompressed) => {
                if (err) {
                    reject(err);
                    return;
                }
                const string = strFromU8(decompressed);

                resolve(string);
            });
        });
    },
};

/**
 * Views must carry their offset and length through: a Node Buffer is usually a
 * window onto a larger pooled ArrayBuffer, so reading its `.buffer` alone would
 * pick up unrelated memory.
 */
const toBytes = (payload: BinaryPayload) => {
    return payload instanceof ArrayBuffer
        ? new Uint8Array(payload)
        : new Uint8Array(payload.buffer, payload.byteOffset, payload.byteLength);
};

export { CompressionHelpers };
